const list = {
  MuiListItem: {
    styleOverrides: {
      root: {},
    },
  },

  MuiListItemAvatar: {
    styleOverrides: {
      root: {
        minWidth: 0,
      },
    },
  },
  MuiListItemText: {
    styleOverrides: {
      primary: {
        fontSize: '14px',
        fontWeight: 400,
      },
    },
  },
  MuiAvatar: {
    styleOverrides: {
      root: {
        width: 30,
        height: 30,
        borderRadius: '4px',
        marginRight: '6px',
      },
    },
  },
};
export default list;
